/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import SidePaneContent from './SidePaneContent';
import SidePaneHeader from './SidePaneHeader';

import './SidePane.scss';

@observer
class SidePane extends Component {

	render() {

		const {
			cardListVM,
			dndManager
		} = this.props;

		return (
			<div className='sidePane'>
				<SidePaneHeader
					cardListVM={cardListVM}
					onContextMenuChange={this.onContextMenuChange}
				/>
				<SidePaneContent
					cardListVM={cardListVM}
					dndManager={dndManager}
					onContextMenuChange={this.onContextMenuChange}
					onDelete={this.onDelete}
				/>
			</div>
		);
	}

	// Events

	onContextMenuChange = ({ menu }, cardId) => {
		const {
			cardListVM
		} = this.props;

		const card = this._getCard(cardId);
		cardListVM.clearContextMenu();
		this.props.cardListVM.performAction(menu, card && [card]);
		//This is needed because after the action takes place, the focus is then set onto glass.
		//TODO: This could be improved if the focus isn't be automatically set by glass, and let each component decide.
		_.defer(() => {
			const { exploreVM } = cardListVM;
			exploreVM.setFocusOnExploreContainer();
		});
	}

	_getCard(id) {
		const {
			cardListVM : {
				layoutModel: exploreContainerLayoutModel
			}
		} = this.props;
		return exploreContainerLayoutModel && exploreContainerLayoutModel.findModel(id);
	}

	onDelete = () => {
		const result = this.props.cardListVM.performAction('deleteCard');
		//This is needed because after the action takes place, the focus is then set onto glass.
		//TODO: This could be improved if the focus isn't be automatically set by glass, and let each component decide.
		_.defer(() => {
			const {
				cardListVM: {
					exploreVM
				}
			} = this.props;
			exploreVM.setFocusOnExploreContainer();
		});
		return result;
	}
}

SidePane.propTypes = {
	cardListVM: PropTypes.object.isRequired,
	dndManager: PropTypes.object.isRequired
};

SidePane.defaultProps = {};

export default SidePane;



// WEBPACK FOOTER //
// ./src/js/components/cards/SidePane.js